import { render, staticRenderFns } from "./BarChartVisitantes.vue?vue&type=template&id=6af3acf9"
import script from "./BarChartVisitantes.vue?vue&type=script&lang=js"
export * from "./BarChartVisitantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports